import { Button } from 'antd'
import styled from 'styled-components'

export const AddButton = styled(Button)`
  border-style: ${(props) => (props.noBorder ? 'none' : 'solid')} !important;
  width: ${(props) => (props.maxWidth ? 'max-content' : '100%')} !important;
  position: ${(props) => (props.absolute ? 'absolute' : 'relative')} !important;
  right: ${(props) => (props.absolute ? '5px !important' : undefined)};
  bottom: ${(props) => (props.absolute ? '0px !important' : undefined)};
  background: ${(props) => (props.noBackground ? 'transparent !important' : undefined)};
  margin-top: 16px;
  box-shadow: none;
  font-weight: 600;

  &:hover {
    background: ${(props) => (props.noBackground ? 'transparent !important' : undefined)};
  }
  &:focus {
    background: ${(props) => (props.noBackground ? 'transparent !important' : undefined)};
  }
`
